import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { pageRoutes } from 'shared/routes';
import { NavigationTabs } from 'shared/ui/NavigationTabs';
import { initTS } from 'widgets/ContractorTSReports';

interface ContractorReportsProps {
  children: JSX.Element;
}

export function ContractorReports({ children }: ContractorReportsProps) {
  const history = useHistory();
  const location = useLocation();

  const getTabId = () => {
    switch (location.pathname) {
      case pageRoutes.app.reportsPerformance:
        return 1;
      case pageRoutes.app.reportsCampaignMap:
        return 2;
      case pageRoutes.app.reportsVerticalBenchmark:
        return 3;
      default:
        return 0;
    }
  };

  const tabs = [
    {
      id: 0,
      text: 'Overview',
      onClick: () => {
        history.push(pageRoutes.app.reportsOverview);
      },
    },
    {
      id: 1,
      text: 'Performance metrics',
      onClick: () => {
        history.push(pageRoutes.app.reportsPerformance);
      },
      tabWidth: 171,
    },
    {
      id: 2,
      text: 'Campaign Expansion Opportunities',
      onClick: () => {
        history.push(pageRoutes.app.reportsCampaignMap);
      },
      tabWidth: 262,
    },
    {
      id: 3,
      text: 'Vertical benchmark',
      onClick: () => {
        history.push(pageRoutes.app.reportsVerticalBenchmark);
      },
      tabWidth: 160,
    },
  ];

  useEffect(() => {
    initTS();
  }, []);

  return (
    <div className="min-w-[500px]">
      <NavigationTabs
        tabs={tabs}
        itemWidth={116}
        selectedId={getTabId()}
      />
      <div className="mt-6 rounded-[10px] bg-deep-blue-25 pb-2">{children}</div>
    </div>
  );
}
